import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// 293: pole pro heslo s okem — klepnutím se heslo ukáže, dalším zase skryje.
export function PasswordInput({ className = "", "data-testid": testid, ...props }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={shown ? "text" : "password"} className={`pr-12 ${className}`} data-testid={testid}
        autoCapitalize="none" autoCorrect="off" spellCheck={false} />
      <button type="button" onClick={() => setShown((v) => !v)} aria-label={shown ? "Skrýt heslo" : "Zobrazit heslo"}
        aria-pressed={shown} data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-1 bottom-0 h-12 w-11 grid place-items-center rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        {shown ? <EyeOff size={19} /> : <Eye size={19} />}
      </button>
    </div>
  );
}
